(function($) {
    let validator = null;
    let hostHeaderTable = {};
    let hostHeaderValues = null;

    const initializeHostHeaderData = function(hostHeaderResponse) {
        let whitelist = [];
        const emptyText = 'Whitelist is empty.';
        let hostHeaders = null;
        
        hostHeaders = hostHeaderResponse.hostHeaders;
        
        const headers = [{
          title: 'Host Values'
        }]
    	
        const hostHeaderTableOptions = {
          columns: [                {
              data : 'hostHeaders',
              render : function(data, type, row) {
                  return row.name;
              },
              className : 'host-container',
              width: '300px'
          }],
          order: [[0, 'asc']],
          data: hostHeaders,
          language: {
            emptyTable: emptyText
          },
          createdRow: function createdRow(row, data, index) {
              if (data.default) {
                  $(row).attr('disabled', 'disabled');
              };
          }
        };
        
        const tableControls = {
	        addButton: {
	            clazz: 'add-button',
	            callback: addHostClickHandler
	        },
			deleteButton: {
				clazz: 'delete-button',
				disabled: 'disabled',
				enablement: 'multi',
				deleteConfirmationCallback: removeHostClickHandler
          	}
        };
        
        const hostHeaderTableComponent = new SimpleTableComponent('hostHeader', '#hostHeaderTableContainer', headers);
        hostHeaderTable = hostHeaderTableComponent.createTable(hostHeaderTableOptions, 'multi', null, null, tableControls);
    };
    
    const removeHostClickHandler = function() {
		let table = $('#hostHeaderTable').DataTable();
		let selectedRow = $(table.$('tr.row_selected')[0]);
		table.rows('.row_selected').remove().draw();
    	updateHosts();
    };
    
    const addHostClickHandler = function() {
    	$.showHostHeaderDialog({okCallback : function() {
    		let table = $('#hostHeaderTable').DataTable();
    		table.row.add({default : false, name: $('#hostHeader').val()}).draw(false);
    		updateHosts();
    	}});
    };
    
    const updateWhitelistEnabled = function() {
    	$.displayLoadingIndicator();
    	
    	var checkbox = $('#hostHeaderCheckbox');
    	var isEnabled = (checkbox.prop('checked'));
    	
        $.ajax({
            type: 'PUT',
            url: 'ws/hostheaders/enabled',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(isEnabled),
            cache: false
          }).done(function (response) {
        	$.showSuccessStatus(response.message);
          }).always(function () {
        	hostHeaderChanged();
            $.removeLoadingIndicator();
          });	
    };
    
    const hostHeaderChanged = function() {
   	  const checkbox = $('#hostHeaderCheckbox');
	    if (checkbox.prop('checked')) {
	    	$('#hostHeaderTableContainer').removeAttr('disabled');
	    	$('#hostHeaderAddButton').removeAttr('disabled');
	    } 
	    else {
	    	$('#hostHeaderTableContainer').attr('disabled', 'disabled');
	    	$('#hostHeaderAddButton').attr('disabled', 'disabled');
	    }
    };
    
    const updateHosts = function () {
        $.displayLoadingIndicator();

		let tableData = $('#hostHeaderTable').DataTable().rows().data();
    	let hostHeaderData = '{hostHeaders:[';
    	Array.from(tableData).forEach(function(row) {
    		if (row.default == false) {
    			hostHeaderData = hostHeaderData + '{isDefault: \" ' + row.isDefault + '", name:\"' + row.name + '\"},';
    		}
    	});
    	
    	//We want to remove the trailing comma, but not the square bracket that's on the end instead if we're sending back an empty list.
    	if (hostHeaderData.charAt(hostHeaderData.length - 1) != '[') {
    		hostHeaderData = hostHeaderData.substring(0, hostHeaderData.length - 1);
    	}
    	else {
    		hostHeaderData = hostHeaderData + '""';
    	}
    	
    	hostHeaderData = hostHeaderData + ']}';
    	

        return $.ajax({
            type: 'PUT',
            url: '/compuware/ws/hostheaders',
            contentType: 'application/json',
            dataType: 'json',
            data: hostHeaderData,
            cache: false
        }).done(function (response) {
        	$.showSuccessStatus(response.message);
        }).fail(function (response) {
            const errorMessage = response.responseText;

            if (!$('#hostHeaderDialog').is(':visible')) {
                $.showErrorStatus(errorMessage);
            }
        }).always(function () {
            $.removeLoadingIndicator();
        });
    };

    $(document).ready(function() {    	
        $.when(
	        $.ajax({
	            type: 'GET',
	            url : 'ws/hostheaders',
	            contentType : 'application/json',
	            accept: 'application/json',
	            dataType : 'json',
	            cache : false
	        })
        ).done(function(response) {
            initializeHostHeaderData(response);
        }).fail(function(error) {
        	console.log(error);
        }).always(function() {
        	hostHeaderChanged();
            $(window).trigger('hostHeadersLoaded');
        });
        
        $.when(
            $.ajax({
                type: 'GET',
                url : 'ws/hostheaders/enabled',
                contentType : 'application/json',
                accept: 'application/json',
                dataType : 'json',
                cache : false
            })
        ).done(function(response) {
        	$.debugLog(response);
            if (response.success == true) {
            	$('#hostHeaderCheckbox').prop('checked', true);
            }
            else {
            	$('#hostHeaderCheckbox').prop('checked', false);
            }
        	hostHeaderChanged();
        }).fail(function(error) {
        	console.log(error);
        });
        $('#hostHeaderCheckbox').on('change', updateWhitelistEnabled);
    });
})(jQuery);